import { render, staticRenderFns } from "./CallInfoModal.vue?vue&type=template&id=37791aac&scoped=true"
import script from "./CallInfoModal.vue?vue&type=script&lang=js"
export * from "./CallInfoModal.vue?vue&type=script&lang=js"
import style0 from "./CallInfoModal.vue?vue&type=style&index=0&id=37791aac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37791aac",
  null
  
)

export default component.exports